// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog__JkT0p"};